export class ApiErrorException extends Error {
  constructor(e, msg) {
    super(msg);
    this.e = e;
  }
}
